module.exports = __webpack_public_path__ + "videos/timelapse_mobile.e42a308.mp4";